import { useState } from "react";
import { ErrorUtils } from "../utils";

export const useLocalStorage = (key: string, initValue?: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);

      return item ? JSON.parse(item) : initValue;
    } catch (error) {
      console.error(error);

      return initValue;
    }
  });

  const setValue = (value: any) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      localStorage.setItem(
        key,
        valueToStore ? JSON.stringify(valueToStore) : "",
      );
    } catch (error) {
      ErrorUtils.showErrorMessage();
    }
  };

  return [storedValue, setValue];
};
